import React, {useCallback, useEffect, useState} from 'react';
import {SeasonList} from "../../../components/admin/season/SeasonList";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {seasonResultCollectionType, seasonResultType} from "../../../types/Api/SeasonResultType";
import {seasonHydrator} from "../../../models/hydrator/seasonHydrator";
import {season} from "../../../models/season";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../types/PaginationType";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";
import {Pagination} from "../../../components/admin/Pagination";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [seasons, setSeasons] = useState([] as season[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findSeason = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'enabled',
      direction: 'DESC'
    });

    apiFilters.addSort({
      by: 'label',
      direction: 'DESC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<seasonResultCollectionType> = ApiService.get('/season', apiFilters) as Promise<seasonResultCollectionType>;

    result
      .then((r: seasonResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setSeasons(r._embedded.seasons.map((season: seasonResultType) => {
          return seasonHydrator.hydrate(season);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setSeasons([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count, page]);

  useEffect(() => {
    findSeason();
  }, [findSeason]);

  return (
    <>
      <BoxTitle title="Gestion des saisons"/>
      <SeasonList seasons={seasons} loading={loading} refresh={findSeason}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/season/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter une saison
        </NavLink>
      </div>
    </>
  )
}
